// BL-402: the seeded skyline strip along the bottom of the sign-in screen. Same generator and seed as the
// film (Appendix A `sky()`), emitted as SVG so the sign-in screen needs no canvas.
const W = 1400;
const H = 260;
let cached = null;

export function skylineSvg() {
    if (cached) return cached;
    let s = 7;
    const rnd = () => (s = (s * 16807) % 2147483647) / 2147483647;
    const shapes = [];
    for (let layer = 0; layer < 2; layer++) {
        let x = -20;
        while (x < W) {
            const w = 30 + rnd() * (layer ? 70 : 50);
            const h = (layer ? 30 : 60) + rnd() * (layer ? 90 : 150) * (rnd() < 0.12 ? 1.5 : 1);
            shapes.push(`<rect x="${x.toFixed(1)}" y="${(H - h).toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" fill="${layer ? '#07090e' : '#0b0e15'}"/>`);
            for (let wy = H - h + 8; wy < H - 4; wy += 9) {
                for (let wx = x + 5; wx < x + w - 5; wx += 7) {
                    if (rnd() < (layer ? 0.08 : 0.14)) {
                        const fill = rnd() < 0.75
                            ? `rgba(255,214,140,${(0.2 + rnd() * 0.4).toFixed(2)})`
                            : `rgba(200,225,255,${(0.2 + rnd() * 0.3).toFixed(2)})`;
                        shapes.push(`<rect x="${wx.toFixed(1)}" y="${wy.toFixed(1)}" width="2" height="3" fill="${fill}"/>`);
                    }
                }
            }
            x += w + rnd() * 6;
        }
    }
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">${shapes.join('')}</svg>`;
    cached = `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
    return cached;
}
